import React, { useEffect, useRef, useState } from "react";
import {
  getPublicSymbolSize,
  getStyle,
  getVisibilityStyle,
  getAdjustedFontSize,
} from "../Common/StylesHelper";
import { hexToRgba } from "utils/Utils";
import PublicPreviewPriceDisplay from "components/common/PublicPreviewPriceDisplay";
import DragScroll from "components/common/DragScroll";
import productGridPlaceholder from "assets/images/productGridPlaceholder.png";
import PublicTagShape from "./PublicTagShape";
import ProductDetailsModal from "./ProductDetailsModal";

const ProductGrid = ({
  products = [],
  config,
  styles,
  primaryColor,
  theme = {},
  layoutSettings,
  scrollDirection,
  currencyInfo,
  language,
  responsiveLayoutType,
  isApplyBlackColor,
}) => {
  return (
    <div className="product_grid_inner">
      {/* {scrollDirection === "horizontal" ? ( */}
      {responsiveLayoutType === "productPreview" ? (
        <HorizontalProductGrid
          products={products}
          config={config}
          layoutSettings={layoutSettings}
          styles={styles}
          currencyInfo={currencyInfo}
          primaryColor={primaryColor}
          theme={theme}
          language={language}
          isApplyBlackColor={isApplyBlackColor}
        />
      ) : responsiveLayoutType === "productGrid1" ? (
        <VerticalProductGrid1
          products={products}
          config={config}
          layoutSettings={layoutSettings}
          styles={styles}
          primaryColor={primaryColor}
          currencyInfo={currencyInfo}
          theme={theme}
          language={language}
          responsiveLayoutType={responsiveLayoutType}
          isApplyBlackColor={isApplyBlackColor}
        />
      ) : (
        <VerticalProductGrid3
          products={products}
          config={config}
          layoutSettings={layoutSettings}
          styles={styles}
          primaryColor={primaryColor}
          theme={theme}
          language={language}
          responsiveLayoutType={responsiveLayoutType}
          currencyInfo={currencyInfo}
          isApplyBlackColor={isApplyBlackColor}
        />
      )}
    </div>
  );
};

export default ProductGrid;

const HorizontalProductGrid = ({
  products = [],
  config,
  styles,
  primaryColor,
  currencyInfo,
  theme = {},
  layoutSettings,
  language,
  isApplyBlackColor,
}) => {
  const {
    showPreviewImage,
    showPrice,
    showCalorie,
    showTitle,
    showAllergens,
    showTags,
  } = config || {};

  const { allergenBackgroundColor } = theme || {};
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { itemSpacing, cardStyle } =
    layoutSettings?.productGrid || {};

  const {
    borderRadius,
    borderWidth,
    backgroundColor,
    backgroundOpacity,
    borderColor,
  } = cardStyle || {};

  const cardStyles = {
    marginTop: itemSpacing,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius,
    backgroundColor: hexToRgba(backgroundColor, backgroundOpacity),
  };

  return (
    <div className="horizontal_product_grid">
      {products?.map((product) => {
        const {
          productId = "",
          productTitle = "",
          productPrice = "",
          productCalorie = "",
          imageUrl = "",
          allergens = [],
          tags = {},
          addonsOptions = {},
        } = product;

        const priceAndSizes = [
          ...(addonsOptions?.priceAndSizes || []),
          ...(addonsOptions?.modifierOptions || []),
        ];

        return (
          <div
            key={productId}
            className="single_card cursor-pointer"
            style={cardStyles}
            onClick={() => setSelectedProduct(product)}
          >
            {showTags && tags && (
              <PublicTagShape
                shape={tags?.id}
                color={tags?.color || "#A47E51"}
                name={tags?.label}
                styles={styles}
                width={60}
                height={60}
                wrapperClass="common_shape_tag"
              />
            )}
            {/* Image */}
            <div className="img_wrapper">
              <img
                src={imageUrl || productGridPlaceholder}
                alt={productTitle}
                style={{
                  width: 162,
                  height: 162,
                  objectFit: "contain",
                  borderRadius,
                  ...getVisibilityStyle(showPreviewImage),
                }}
              />
            </div>
            {/* Content */}
            <div className="content_wrapper w-100">
              <ScrollingTitle
                style={{
                  ...getStyle(styles, "productTitle"),
                  ...getVisibilityStyle(showTitle),
                  ...(isApplyBlackColor && { color: "#000" }),
                  fontSize: getAdjustedFontSize(14, styles?.productTitle?.family),
                }}
              >
                {productTitle}
              </ScrollingTitle>
              <p
                className="product-price ltr w_fit_content"
                style={{
                  ...getStyle(styles, "productPrice"),
                  ...getVisibilityStyle(showPrice),
                  ...(isApplyBlackColor && { color: "#000" }),
                }}
              >
                {/* <CurrencySymbol
                  color={styles["productPrice"].color || primaryColor}
                  width={width}
                  height={height}
                />
                <span>{productPrice}</span> */}
                <PublicPreviewPriceDisplay
                  currencyInfo={currencyInfo}
                  productPrice={productPrice}
                  width={10}
                  height={10}
                  primaryColor={
                    isApplyBlackColor
                      ? "#000"
                      : styles["productPrice"].color || primaryColor
                  }
                  extraSpanStyles={{
                    fontSize: getAdjustedFontSize(14, styles?.productPrice?.family),
                  }}
                />
              </p>
              <p
                style={{
                  ...getStyle(styles, "productCalorie"),
                  ...getVisibilityStyle(showCalorie),
                  ...(isApplyBlackColor && { color: "#000" }),
                  fontSize: getAdjustedFontSize(10, styles?.productCalorie?.family),
                }}
                className="product_calorie w_fit_content"
              >
                {productCalorie}
              </p>

              {allergens?.length > 0 && showAllergens ? (
                <div
                  className="allergens allergens_div"
                  style={{ maxWidth: "100%", width: "100%" }}
                >
                  {/* <h5 style={getThemeFontStyles(theme)}>
                    {getAllergenText(language)}
                  </h5> */}
                  <DragScroll className="inner_section allergen_inner">
                    {allergens?.map((allergen, idx) => (
                      <div
                        key={idx}
                        className="inner_div"
                        style={{
                          "--theme-primary-color": allergenBackgroundColor,
                        }}
                      >
                        <img
                          src={allergen?.url}
                          width={15}
                          height={15}
                          alt=""
                        />
                      </div>
                    ))}
                  </DragScroll>
                </div>
              ) : null}
              <div className="addon_prices_wrapper">
                {priceAndSizes.length > 0 && (
                  <div className="price-and-sizes-container">
                    <DragScroll className="inner_section">
                      {priceAndSizes.map((sizeOption) => (
                        <div
                          key={sizeOption.id}
                          className="size-price-item"
                          style={{
                            borderColor:
                              { ...getStyle(styles, "productTitle") } || "#fff",
                          }}
                        >
                          <span
                            className="size-name"
                            title={sizeOption.name}
                            style={{
                              ...getStyle(styles, "productTitle"),
                              ...(isApplyBlackColor && { color: "#000" }),
                              whiteSpace: "nowrap",
                              fontSize: getAdjustedFontSize(
                                8,
                                styles?.productTitle?.family
                              ),
                            }}
                          >
                            {sizeOption.name}
                          </span>
                          <span
                            className="size-price ltr w_fit_content"
                            title={`${sizeOption.price}`}
                            style={{
                              ...getStyle(styles, "productTitle"),
                              ...(isApplyBlackColor && { color: "#000" }),
                              fontSize: getAdjustedFontSize(
                                8,
                                styles?.productTitle?.family
                              ),
                            }}
                          >
                            <PublicPreviewPriceDisplay
                              currencyInfo={currencyInfo}
                              productPrice={sizeOption.price}
                              width={10}
                              height={10}
                              primaryColor={
                                isApplyBlackColor
                                  ? "#000"
                                  : styles["productTitle"]?.color ||
                                    primaryColor
                              }
                              extraSpanStyles={{
                                fontSize: getAdjustedFontSize(
                                  12,
                                  styles?.productTitle?.family
                                ),
                              }}
                            />
                          </span>
                        </div>
                      ))}
                    </DragScroll>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
      <ProductDetailsModal
        show={!!selectedProduct}
        product={selectedProduct}
        language={language}
        onHide={() => setSelectedProduct(null)}
        currencyInfo={currencyInfo}
        styles={styles}
        primaryColor={primaryColor}
        isApplyBlackColor={isApplyBlackColor}
        config={config}
        theme={theme}
      />
    </div>
  );
};

const VerticalProductGrid1 = ({
  products = [],
  config,
  styles,
  primaryColor,
  currencyInfo,
  theme = {},
  layoutSettings,
  language,
  responsiveLayoutType, // productGrid1, productGrid3
  isApplyBlackColor,
}) => {
  const {
    showPreviewImage,
    showPrice,
    showCalorie,
    showTitle,
    showAllergens,
    showTags,
  } = config || {};

  const { width, height } = getPublicSymbolSize(styles?.productPrice?.size);
  const { allergenBackgroundColor } = theme || {};
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { itemSpacing, cardStyle } = layoutSettings?.productGrid || {};

  const {
    borderRadius,
    borderWidth,
    backgroundColor,
    borderColor,
    backgroundOpacity,
  } = cardStyle || {};

  const cardStyles = {
    marginTop: itemSpacing,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius,
    backgroundColor: hexToRgba(backgroundColor, backgroundOpacity),
  };

  return (
    <div className="vertical_product_grid m-0 row">
      {products?.map((product) => {
        const {
          productId = "",
          productTitle = "",
          productDescription = "",
          productPrice = "",
          productCalorie = "",
          imageUrl = "",
          allergens = [],
          tags = {},
          addonsOptions = {},
        } = product;

        const priceAndSizes = [
          ...(addonsOptions?.priceAndSizes || []),
          ...(addonsOptions?.modifierOptions || []),
        ];

        return (
          <div className="col-6" key={productId}>
            <div
              key={productId}
              className="single_card cursor-pointer"
              style={cardStyles}
              onClick={() => setSelectedProduct(product)}
            >
              {showTags && tags && (
                <PublicTagShape
                  shape={tags?.id}
                  color={tags?.color || "#A47E51"}
                  name={tags?.label}
                  styles={styles}
                  width={60}
                  height={60}
                  wrapperClass="common_shape_tag"
                />
                // <ProductTagShape
                //   tags={tags}
                //   shapeOptions={shapeOptions}
                //   styles={styles}
                //   primaryColor={primaryColor}
                //   width={60}
                //   height={60}
                // />
              )}
              {/* Image */}
              <div className="img_wrapper">
                <img
                  src={imageUrl || productGridPlaceholder}
                  alt={productTitle}
                  style={{
                    width: "100%",
                    height: 194,
                    objectFit: "contain",
                    borderRadius,
                    ...getVisibilityStyle(showPreviewImage),
                  }}
                />
              </div>
              {/* Content */}
              <div className="content_wrapper w-100">
                {/* TITLE & PRICE */}
                <ScrollingTitle
                  style={{
                    ...getStyle(styles, "productTitle"),
                    ...getVisibilityStyle(showTitle),
                    ...(isApplyBlackColor && { color: "#000" }),
                    fontSize: getAdjustedFontSize(14, styles?.productTitle?.family),
                  }}
                >
                  {productTitle}
                </ScrollingTitle>
                <div className="g_between gap-2 mt_10">
                  <p
                    className="product-price ltr"
                    style={{
                      ...getStyle(styles, "productPrice"),
                      ...getVisibilityStyle(showPrice),
                      ...(isApplyBlackColor && { color: "#000" }),
                    }}
                  >
                    {/* <CurrencySymbol
                      color={styles["productPrice"].color || primaryColor}
                      width={width}
                      height={height}
                    />
                    <span>{productPrice}</span> */}
                    <PublicPreviewPriceDisplay
                      currencyInfo={currencyInfo}
                      productPrice={productPrice}
                      width={10}
                      height={10}
                      primaryColor={
                        isApplyBlackColor
                          ? "#000"
                          : styles["productPrice"].color || primaryColor
                      }
                      extraSpanStyles={{
                        fontSize: getAdjustedFontSize(14, styles?.productPrice?.family),
                      }}
                    />
                  </p>
                  <p
                    style={{
                      ...getStyle(styles, "productCalorie"),
                      ...getVisibilityStyle(showCalorie),
                      ...(isApplyBlackColor && { color: "#000" }),
                      whiteSpace: "nowrap",
                      fontSize: getAdjustedFontSize(10, styles?.productCalorie?.family),
                    }}
                    className="product_calorie"
                  >
                    {productCalorie}
                  </p>
                </div>
                {/* ALLERGEN & CALORIE */}
                <div className="g_between gap-2 mt-1">
                  {allergens?.length > 0 && showAllergens ? (
                    <div
                      className="allergens allergens_div g_between gap-1"
                      style={{ maxWidth: "100%", width: "100%" }}
                    >
                      {/* <h5 style={getThemeFontStyles(theme)} >
                        {getAllergenText(language)}
                      </h5> */}
                      <DragScroll className="inner_section allergen_inner pb-0">
                        {allergens?.map((allergen, idx) => (
                          <div
                            key={idx}
                            className="inner_div"
                            style={{
                              "--theme-primary-color": allergenBackgroundColor,
                            }}
                          >
                            <img
                              src={allergen?.url}
                              width={width}
                              height={height}
                              alt=""
                            />
                          </div>
                        ))}
                      </DragScroll>
                    </div>
                  ) : null}
                </div>
                <div className="addon_prices_wrapper">
                  {priceAndSizes.length > 0 && (
                    <div className="price-and-sizes-container">
                      <DragScroll className="inner_section">
                        {priceAndSizes.map((sizeOption) => (
                          <div
                            key={sizeOption.id}
                            className="size-price-item"
                            style={{
                              borderColor:
                                { ...getStyle(styles, "productTitle") } ||
                                "#fff",
                            }}
                          >
                            <span
                              className="size-name"
                              title={sizeOption.name}
                              style={{
                                ...getStyle(styles, "productTitle"),
                                ...(isApplyBlackColor && { color: "#000" }),
                                whiteSpace: "nowrap",
                                fontSize: getAdjustedFontSize(
                                  8,
                                  styles?.productTitle?.family
                                ),
                              }}
                            >
                              {sizeOption.name}
                            </span>
                            <span
                              className="size-price ltr w_fit_content"
                              title={`${sizeOption.price}`}
                              style={{
                                ...getStyle(styles, "productTitle"),
                                ...(isApplyBlackColor && { color: "#000" }),
                                fontSize: getAdjustedFontSize(
                                  8,
                                  styles?.productTitle?.family
                                ),
                              }}
                            >
                              <PublicPreviewPriceDisplay
                                currencyInfo={currencyInfo}
                                productPrice={sizeOption.price}
                                width={10}
                                height={10}
                                primaryColor={
                                  isApplyBlackColor
                                    ? "#000"
                                    : styles["productTitle"]?.color ||
                                      primaryColor
                                }
                                extraSpanStyles={{
                                  fontSize: getAdjustedFontSize(
                                    12,
                                    styles?.productTitle?.family
                                  ),
                                }}
                              />
                            </span>
                          </div>
                        ))}
                      </DragScroll>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <ProductDetailsModal
        show={!!selectedProduct}
        product={selectedProduct}
        language={language}
        onHide={() => setSelectedProduct(null)}
        currencyInfo={currencyInfo}
        styles={styles}
        primaryColor={primaryColor}
        isApplyBlackColor={isApplyBlackColor}
        config={config}
        theme={theme}
      />
    </div>
  );
};
const VerticalProductGrid3 = ({
  products = [],
  config,
  styles,
  primaryColor,
  theme = {},
  layoutSettings,
  language,
  responsiveLayoutType, // productGrid1, productGrid3
  currencyInfo,
  isApplyBlackColor,
}) => {
  const {
    showPreviewImage,
    showPrice,
    showCalorie,
    showTitle,
    showAllergens,
    showTags,
  } = config || {};

  const { width, height } = getPublicSymbolSize(styles?.productPrice?.size);
  const { allergenBackgroundColor } = theme || {};
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { itemSpacing, cardStyle } = layoutSettings?.productGrid || {};

  const {
    borderRadius,
    borderWidth,
    backgroundColor,
    borderColor,
    backgroundOpacity,
  } = cardStyle || {};

  const cardStyles = {
    marginTop: itemSpacing,
    border: `${borderWidth}px solid ${borderColor}`,
    borderRadius,
    backgroundColor: hexToRgba(backgroundColor, backgroundOpacity),
  };

  return (
    <div className="vertical_product_grid m-0 row">
      {products?.map((product) => {
        const {
          productId = "",
          productTitle = "",
          productDescription = "",
          productPrice = "",
          productCalorie = "",
          imageUrl = "",
          allergens = [],
          tags = {},
          addonsOptions = {},
        } = product;

        const priceAndSizes = [
          ...(addonsOptions?.priceAndSizes || []),
          ...(addonsOptions?.modifierOptions || []),
        ];

        return (
          <div
            key={productId}
            className="single_card cursor-pointer"
            style={cardStyles}
            onClick={() => setSelectedProduct(product)}
          >
            {showTags && tags && (
              <PublicTagShape
                shape={tags?.id}
                color={tags?.color || "#A47E51"}
                name={tags?.label}
                styles={styles}
                width={60}
                height={60}
                wrapperClass="common_shape_tag"
              />
            )}
            {/* Image */}
            <div className="img_wrapper">
              <img
                src={imageUrl || productGridPlaceholder}
                alt={productTitle}
                style={{
                  width: "100%",
                  height: 194,
                  objectFit: "contain",
                  borderRadius,
                  ...getVisibilityStyle(showPreviewImage),
                }}
              />
            </div>
            {/* Content */}
            <div className="content_wrapper w-100">
              {/* TITLE & PRICE */}
              <div className="g_between gap-2 mt_10">
                <ScrollingTitle
                  style={{
                    ...getStyle(styles, "productTitle"),
                    ...getVisibilityStyle(showTitle),
                    ...(isApplyBlackColor && { color: "#000" }),
                    fontSize: getAdjustedFontSize(14, styles?.productTitle?.family),
                  }}
                >
                  {productTitle}
                </ScrollingTitle>
                <p
                  className="product-price ltr"
                  style={{
                    ...getStyle(styles, "productPrice"),
                    ...getVisibilityStyle(showPrice),
                    ...(isApplyBlackColor && { color: "#000" }),
                  }}
                >
                  {/* <CurrencySymbol
                    color={styles["productPrice"].color || primaryColor}
                    width={width}
                    height={height}
                  />
                  <span>{productPrice}</span> */}
                  <PublicPreviewPriceDisplay
                    currencyInfo={currencyInfo}
                    productPrice={productPrice}
                    width={10}
                    height={10}
                    primaryColor={
                      isApplyBlackColor
                        ? "#000"
                        : styles["productPrice"].color || primaryColor
                    }
                    extraSpanStyles={{
                      fontSize: getAdjustedFontSize(14, styles?.productPrice?.family),
                    }}
                  />
                </p>
              </div>
              {/* ALLERGEN & CALORIE */}
              <div className="g_between gap-2 mt-1">
                {allergens?.length > 0 && showAllergens ? (
                  <div
                    className="allergens allergens_div"
                    style={{ maxWidth: "100%", width: "100%" }}
                  >
                    {/* <h5 style={getThemeFontStyles(theme)} className="mb-3">
                      {getAllergenText(language)}
                    </h5> */}
                    <DragScroll className="inner_section allergen_inner">
                      {allergens?.map((allergen, idx) => (
                        <div
                          key={idx}
                          className="inner_div"
                          style={{
                            "--theme-primary-color": allergenBackgroundColor,
                          }}
                        >
                          <img
                            src={allergen?.url}
                            width={15}
                            height={15}
                            alt=""
                          />
                        </div>
                      ))}
                    </DragScroll>
                  </div>
                ) : null}
                <p
                  style={{
                    ...getStyle(styles, "productCalorie"),
                    ...getVisibilityStyle(showCalorie),
                    ...(isApplyBlackColor && { color: "#000" }),
                    whiteSpace: "nowrap",
                    fontSize: getAdjustedFontSize(10, styles?.productCalorie?.family),
                  }}
                  className="product_calorie"
                >
                  {productCalorie}
                </p>
              </div>
              <div className="addon_prices_wrapper">
                {priceAndSizes.length > 0 && (
                  <div className="price-and-sizes-container">
                    <DragScroll className="inner_section">
                      {priceAndSizes.map((sizeOption) => (
                        <div
                          key={sizeOption.id}
                          className="size-price-item"
                          style={{
                            borderColor:
                              { ...getStyle(styles, "productTitle") } || "#fff",
                          }}
                        >
                          <span
                            className="size-name product_grid_3"
                            title={sizeOption.name}
                            style={{
                              ...getStyle(styles, "productTitle"),
                              ...(isApplyBlackColor && { color: "#000" }),
                              fontSize: getAdjustedFontSize(
                                8,
                                styles?.productTitle?.family
                              ),
                            }}
                          >
                            {sizeOption.name}
                          </span>
                          <span
                            className="size-price ltr w_fit_content"
                            title={`${sizeOption.price}`}
                            style={{
                              ...getStyle(styles, "productTitle"),
                              ...(isApplyBlackColor && { color: "#000" }),
                              fontSize: getAdjustedFontSize(
                                8,
                                styles?.productTitle?.family
                              ),
                            }}
                          >
                            <PublicPreviewPriceDisplay
                              currencyInfo={currencyInfo}
                              productPrice={sizeOption.price}
                              width={10}
                              height={10}
                              primaryColor={
                                isApplyBlackColor
                                  ? "#000"
                                  : styles["productTitle"]?.color ||
                                    primaryColor
                              }
                              extraSpanStyles={{
                                fontSize: getAdjustedFontSize(
                                  12,
                                  styles?.productTitle?.family
                                ),
                              }}
                            />
                          </span>
                        </div>
                      ))}
                    </DragScroll>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
      <ProductDetailsModal
        show={!!selectedProduct}
        product={selectedProduct}
        language={language}
        onHide={() => setSelectedProduct(null)}
        currencyInfo={currencyInfo}
        styles={styles}
        primaryColor={primaryColor}
        isApplyBlackColor={isApplyBlackColor}
        config={config}
        theme={theme}
      />
    </div>
  );
};
const ScrollingTitle = ({ children, style }) => {
  const textRef = useRef(null);
  const wrapperRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      const text = textRef.current;
      const wrapper = wrapperRef.current;

      if (text && wrapper) {
        const textWidth = text.getBoundingClientRect().width;
        const wrapperWidth = wrapper.getBoundingClientRect().width;

        setShouldScroll(textWidth > wrapperWidth);
      }
    });

    return () => cancelAnimationFrame(raf);
  }, [children, style]);

  return (
    <div ref={wrapperRef} className="scroll-wrapper">
      <div className={`scroll-track ${shouldScroll ? "scroll" : ""}`}>
        <h5 style={style} className="scroll-item">
          {/* ← measure this span, no padding affects it */}
          <span ref={textRef}>{children}</span>
        </h5>
        {shouldScroll && (
          <h5 style={style} className="scroll-item">
            <span>{children}</span>
          </h5>
        )}
      </div>
    </div>
  );
};
